/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowHomeImprovementProjectTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowHomeImprovementProject,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Improve Our Space!",
    "Home Project Awaits!",
    "DIY Together!",
  ],
  title: "Home Improvement Project",
  description: "Organize a fun home improvement project.",
  longDescription:
    "Gather your friends for a home improvement project! Choose a date, decide on tasks, and plan activities for the day!",
  emoji: "🛠",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Home Improvement Project",
          emoji: "🛠",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we start the home improvement project?",
          emoji: "📅",
          completeAction: {
            question: "Decide on tasks to tackle?",
            description: "What tasks do we want to work on together?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What tasks should we focus on?",
                emoji: "🔨",
                completeAction: {
                  question: "Decide on tools needed?",
                  description: "What tools should we gather for the project?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What tools should we bring?",
                      emoji: "🧰",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Get to Work!",
    outroDescription:
      "Your home improvement project plans are set! Enjoy the teamwork!",
  },
};
